module.exports = Object.freeze({
    NONE: 0, // RESERVED FOR LATER USE
    DELETED: 1, // RESERVED FOR LATER USE
    SUSPENDED: 2,
    REJECTED_BY_PARENT: 3,
    REJECTED_BY_CHILD: 4,
    REQUESTED_BY_CHILD: 5,
    INVITED_BY_PARENT: 6,
    ACCEPTED_BY_PARENT: 7,
    ACCEPTED_BY_CHILD: 8,
});
